import {
  Box,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Button from 'components/Button';
import messages from 'components/ItemInfoCard/messages';
import {
  ReversedStyledGrid,
  StyledCaption,
  StyledCaptionValue,
  StyledCard,
  StyledGrid,
  StyledIcon,
  StyledLongBody,
  StyledResGrid,
} from 'components/ItemInfoCard/styles';
import { AutoInfoCardProps, styles } from 'components/ItemInfoCard/types';
import StatusChip from 'components/StatusChip';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import MyContractBackground from 'images/BG-divider.svg';
import { sanlamDarkBlue, sanlamYellow } from 'Material-UI/colors';
import React from 'react';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PAGES from 'routes/pages';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { uppercase } from 'utils/string';

const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '90px !important',
    borderRadius: '6px',
    color: '#285BC7 !important',
    border: '1px solid #FFFFFF !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});

const AutoInfoCard = (props: AutoInfoCardProps) => {
  const {
    dateValue,
    numValue,
    title,
    status,
    wrapperPaddingLeft,
    wrapperPaddingRight,
    statusLabel,
  } = props;
  const classes = useStyles();
  const styles: styles = {
    icon: 'AutoMainIcon',
    titleColor: sanlamYellow,
    labelsColor: '#D0DAF3',
    valuesColor: '#FFF',
    backgroundImage: MyContractBackground,
    buttonRootStyles: classes.root,
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = lang === LANGUAGES.AR;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <StyledCard
      backgroundImage={styles.backgroundImage}
      backgroundColor={styles.backgroundColor}
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom="17px"
      >
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid>
            <ReversedStyledGrid
              reverse={reverse}
              container
              justify="space-between"
            >
              <Grid>
                {styles.icon && (
                  <StyledGrid textAlign="center" height="30px">
                    <StyledIcon
                      width={matches ? '29px' : '34px'}
                      height={matches ? '29px' : '34px'}
                      src={AssuranceIcon[styles.icon]}
                      alt="item-icon"
                    />
                  </StyledGrid>
                )}
              </Grid>
              <Grid>
                <Box paddingLeft="6px" paddingTop="6px">
                  <StyledLongBody matches={matches} color={styles.titleColor}>
                    {uppercase(title || '')}
                  </StyledLongBody>
                </Box>
              </Grid>
            </ReversedStyledGrid>
          </Grid>
          <StyledGrid item xs={3} textAlign="end">
            <StatusChip matches={matches} status={status} label={statusLabel} />
          </StyledGrid>
        </ReversedStyledGrid>
      </StyledGrid>
      <Grid container justify="space-between">
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid item>
            <StyledCaption
              matches={matches}
              color={styles.labelsColor || '#9797AF'}
              marginBottom="6px"
            >
              {uppercase(translate({ ...messages.dateEcheance }, props))}
            </StyledCaption>
          </Grid>
          <Grid item>
            <StyledCaptionValue
              matches={matches}
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="6px"
              textAlign="end"
            >
              {dateValue}
            </StyledCaptionValue>
          </Grid>
        </ReversedStyledGrid>
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid item>
            <StyledCaption
              matches={matches}
              color={styles.labelsColor || '#9797AF'}
            >
              {uppercase(translate({ ...messages.numPolice }, props))}
            </StyledCaption>
          </Grid>
          <Grid item>
            <StyledCaptionValue
              matches={matches}
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              textAlign="end"
              marginBottom="15px"
            >
              {numValue}
            </StyledCaptionValue>
          </Grid>
        </ReversedStyledGrid>
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid>
            <GaClickHOC
              category={EVENT_CATEGORIES.AUTO_ACCEUIL}
              label="Mes Contrats Auto_Voir tous"
            >
              <Button
                variant="outlined"
                className={styles.buttonRootStyles}
                size="small"
                onClick={() => {
                  props.setDetailsPageBreadcrumbsPath([
                    { name: 'auto', route: PAGES.AUTODASHBOARD },
                    { name: 'contractEtGarantie' },
                  ]);
                  pushTo(PAGES.AUTO_DETAILS);
                }}
              >
                <StyledResGrid matches={matches}>
                  {translate({ ...messages.voirTous }, props)}
                </StyledResGrid>
              </Button>
            </GaClickHOC>
          </Grid>
        </ReversedStyledGrid>
      </Grid>
    </StyledCard>
  );
};

export default injectIntl(AutoInfoCard);
